/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useState } from "react";
import { hitApi } from "../utils/apiCall.js";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { Button, Form, Modal } from "react-bootstrap";
import NoData from "./assets/NoData.jpg";
import accessDenied from "../pages/assets/accessDenied.png";
import { hitApi2 } from "../utils/apiCall2.js";

const mId = 13;
const sId = 2;

function TeacherAttendance() {
  const navigate = useNavigate();
  const [sundayMsg, setSundayMsg] = useState("");
  const [statusMsg, setStatusMsg] = useState(false);
  const [theme] = useState(localStorage.getItem("theme"));
  const [branchKeys, setBranchKeys] = useState([]);
  const [roleKeys, setRoleKeys] = useState([]);
  const [sectionKeys, setSectionKeys] = useState([]);
  const [attendanceData, setAttendanceData] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [totalAttendance, setTotalAttendance] = useState({});
  const [isAllAttendance, setIsAllAttendance] = useState(false);
  const date = new Date();
  const formatNumber = (num) => num.toString().padStart(2, "0");
  const [selectedDate, setSelectedDate] = useState(
    `${date.getFullYear()}-${formatNumber(date.getMonth() + 1)}-${formatNumber(
      date.getDate()
    )}`
  );
  const isSelectedDateIsSunday = new Date(selectedDate).getDay() === 0;
  const [selectedRow, setSelectedRow] = useState(null);
  const [showNoteModal, setShowNoteModal] = useState(null);

  // ------------********************--------------*****************--------------

  const [data, setData] = useState([]);
  const [badResErr, setBadResErr] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [isSunday, setIsSunday] = useState(false);
  const [isNoRecord, setIsNoRecord] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [reload, setReload] = useState(false);
  const [counts, setCounts] = useState({
    T: 0,
    P: 0,
    A: 0,
    L: 0,
    H: 0,
  });

  const [access, setAccess] = useState({});

  useEffect(() => {
    async function getAccessDetails() {
      const fd = new FormData();
      fd.append("subMenu", sId);
      fd.append("menuId", mId);
      const res = await hitApi("permission/permission", "getAccessDetails", fd);
      if (res.success) {
        setAccess(res.data[0]);
      } else {
        setAccess({});
      }
    }
    getAccessDetails();
  }, []);

  useEffect(() => {
    if (rowData) {
      const newCounts = { P: 0, A: 0, L: 0, H: 0, T: 0 };
      rowData.forEach((item) => {
        newCounts.T++;
        if (item?.status === "P") newCounts.P++;
        if (item?.status === "A") newCounts.A++;
        if (item?.status === "L") newCounts.L++;
        if (item?.status === "H") newCounts.H++;
      });
      setCounts(newCounts);
    }
  }, [rowData]);

  useEffect(() => {
    isSelectedDateIsSunday
      ? setSundayMsg("Selected date is Sunday")
      : setSundayMsg("");
  }, [isSelectedDateIsSunday]);

  // Utility function to fetch and parse local storage
  const getStoredKeys = (key) => {
    const storedData = JSON.parse(localStorage.getItem(key)) || {};
    return Object.keys(storedData)
      .filter((key) => storedData[key])
      .map(Number);
  };

  useEffect(() => {
    setBranchKeys(getStoredKeys("branchForTeacher"));
    setRoleKeys(getStoredKeys("role"));
  }, []);

  // Absent Button
  useEffect(() => {
    if (totalAttendance) {
      const totalCount =
        totalAttendance.totalPresent +
        totalAttendance.totalAbsent +
        totalAttendance.totalLate +
        totalAttendance.totalHalfDay;
      const result = totalCount === totalAttendance.totalStudents;
      setIsAllAttendance(result);
    }
  }, [totalAttendance]);

  useEffect(() => {
    async function fetchTeacherDetails(branches, role, dates) {
      setStatusMsg("");
      setLoadingData(true);
      setIsNoRecord(false);
      setIsSunday(false);
      setData([]);

      const fd = new FormData();
      branches.forEach((ele) => fd.append("branch[]", ele));
      role.forEach((ele) => fd.append("role", ele));
      fd.append("date", dates);

      fd.forEach((v, k) => console.log(k, v));
      const res = await hitApi(
        "attendance/staffAttedance",
        "getStaffDetails",
        fd
      );

      console.log("teacher", res);

      if (res?.message === "Request failed with status code 500") {
        setBadResErr(true);
      } else {
        setBadResErr(false);
      }

      if (res?.success && Array.isArray(res.data) && res.data.length > 0) {
        setData(res.data);
        setIsSunday(false);
        setRowData(
          res.data.map((att) => ({
            staffId: att.staffId,
            status: att.attendanceStatus || "P",
            remark: "",
          }))
        );
        setIsNoRecord(false);
      } else {
        if (res?.data === "Selected date is Sunday") {
          setStatusMsg("sunday");
          setIsSunday(true);
        } else if (
          res?.data === "No Data Found" ||
          (Array.isArray(res?.data) && res.data.length === 0)
        ) {
          setStatusMsg("nodata");
          setIsNoRecord(true);
        }
        setData([]);
        setRowData([]);
      }

      setLoadingData(false);
    }
    branchKeys?.length > 0 &&
      roleKeys.length > 0 &&
      selectedDate &&
      fetchTeacherDetails(branchKeys, roleKeys, selectedDate);
  }, [branchKeys, roleKeys, selectedDate, reload]);

  async function handleAddAttendance() {
    setLoadingBtn(true);
    const fd = new FormData();
    branchKeys.forEach((ele) => fd.append("branch", ele));
    fd.append("date", selectedDate);
    rowData.forEach((ele) => {
      fd.append("staffId[]", ele.staffId);
      fd.append("attendance[]", ele.status);
      fd.append("remarks[]", ele.remark || "");
    });
    fd.forEach((v, k) => console.log(k, v));
    const res = await hitApi2("attendance/staffAttedance", "addAttendance", fd);
    console.log(res);

    if (res.success) {
      toast.success(res.message);
      setLoadingBtn(false);
      setReload((prev) => !prev);
    } else {
      setLoadingBtn(false);
      res.errors?.forEach((ele) => toast.error(ele));
    }
  }

  // Add Note Function
  async function handleAddNote(e) {
    e.preventDefault();
    const fd = new FormData(e.target);
    const res = await hitApi("teacher/attendanceCurl", "addNoteForStudent", fd);
    if (res.success) {
      toast.success(res.data);
      setShowNoteModal(false);
    } else {
      toast.success(res.data);
      setShowNoteModal(false);
    }
  }

  // -----------*************----------------  Handle attendance selection From ERP ---------****************-------------------
  const handleAttendanceChange = (index, field, value) => {
    setRowData((prevAttendanceData) => {
      const updatedAttendanceData = [...prevAttendanceData];
      updatedAttendanceData[index] = {
        ...updatedAttendanceData[index],
        [field]: value,
      };
      return updatedAttendanceData;
    });
  };

  async function handleUpdate(e) {
    e.preventDefault();
    const fd = new FormData(e.target);
    fd.forEach((v, k) => console.log(k, v));
    const res = await hitApi("attendance/attendance", "updateAttendance", fd);

    if (res.success) {
      toast.success(res.message);
      setReload((prev) => !prev);
      setShowEditModal(false);
      setSelectedRow(null);
    } else {
      res.messages.forEach((ele) => toast.error(ele));
      // setShowEditModal(false);
    }
  }
  // console.log(
  //   data.length !== 0,
  //   counts.T === counts.P + counts.H + counts.A + counts.L,
  //   !data.some((item) => item?.attendanceId)
  // );

  return (
    <>
      <div className="page-content-wrapper mt-0">
        <div className="d-flex align-items-center px-3  bg-white border-bottom  p-2">
          <button
            className="btn btn-link text-primary p-2 me-2"
            onClick={() => navigate(-1)}
            style={{ fontSize: "20px" }}
          >
            <i className="bi bi-arrow-left"></i>
          </button>
          <h6 className="m-0">Select Role & Branch</h6>
        </div>
        {access?.is_view === "0" && (
          <div className="d-flex flex-column justify-content-center align-items-center">
            <img src={accessDenied} alt="" />
            <br />
            <h1>No access</h1>
          </div>
        )}
        {access?.is_view === "1" && (
          <>
            <div className=" mt-2">
              {/* Student Search and Date */}
              <div
                className="bg-white py-2 px-1 d-flex justify-content-center align-items-center"
                id="headerArea"
              >
                <div className="container row ps-3 pe-3">
                  <div className="form-group col-8 px-0 d-flex justify-content-center align-items-center m-0">
                    <input
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                      }}
                      type="text"
                      placeholder="Search by Staff Name"
                      className="form-control rounded-3 py-2 h-100"
                    />
                  </div>
                  <div className="form-group pe-0 col-4 d-flex justify-content-center align-items-center m-0">
                    <input
                      value={selectedDate}
                      onChange={(e) => {
                        setSelectedDate(e.target.value);
                      }}
                      type="date"
                      placeholder="Select Date"
                      className="form-control rounded-3 py-2 w-100 h-100"
                    />
                  </div>
                </div>
              </div>

              {/* Absent Button */}
              {isAllAttendance && (
                <div
                  className="bg-white py-2 px-1 d-flex justify-content-center align-items-center"
                  id="headerArea"
                >
                  <div className="container row">
                    <div className="form-group d-flex justify-content-center align-items-center m-0">
                      <button className="btn btn-outline-danger w-100">
                        Send Absent Message
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* Attendance  */}
            <div
              className="container p-2"
              style={{
                maxHeight: "73vh",
                overflow: "hidden",
                overflowY: "auto",
              }}
            >
              {data?.length > 0 ? (
                <div className="container mt-2">
                  {data.map((teacher, idx) => (
                    <div
                      key={teacher.staffId}
                      className="card mb-2 shadow-sm rounded-3 p-2"
                    >
                      <div
                        className="card-body p-2"
                        style={{ fontSize: "0.8rem" }}
                      >
                        <span className="fw-bold">{teacher.staffName}</span>
                        <div className="d-flex">
                          {["P", "A", "H", "L"].map((status) => (
                            <div
                              className="form-check form-check-inline"
                              key={`${teacher.staffId}-${status}`}
                            >
                              <input
                                className={`form-check-input ${
                                  status === "A"
                                    ? "form-check-danger"
                                    : status === "P"
                                    ? "form-check-success"
                                    : status === "L"
                                    ? "form-check-info"
                                    : "form-check-warning"
                                }`}
                                type="radio"
                                name={`teacher_attendance_${teacher.staffId}`}
                                id={`teacher-radio-${status}-${teacher.staffId}`}
                                value={status}
                                checked={rowData[idx]?.status === status}
                                onChange={(e) =>
                                  handleAttendanceChange(
                                    idx,
                                    "status",
                                    e.target.value
                                  )
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`teacher-radio-${status}-${teacher.staffId}`}
                              >
                                <small>
                                  {status === "P"
                                    ? "Present"
                                    : status === "A"
                                    ? "Absent"
                                    : status === "H"
                                    ? "Holiday"
                                    : "Leave"}
                                </small>
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-5 text-muted">
                  <h6>No Data Found</h6>
                </div>
              )}

              {data.length !== 0 &&
                counts.T === counts.P + counts.H + counts.A + counts.L &&
                // !data.some((item) => item?.attendanceId) &&
                access?.is_add === "1" && (
                  <div style={{ padding: "0 12px" }}>
                    <button
                      disabled={loadingBtn}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleAddAttendance();
                      }}
                      className="btn btn-primary w-100"
                    >
                      {loadingBtn ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Loading...
                        </>
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                )}
            </div>
            {/* Footer Showing Total */}
            <div
              style={{ background: "#2d3091" }}
              className="position-fixed bottom-0 left-0 right-0 w-100 shadow"
              id="footerNav"
            >
              <div className="container px-0 py-1">
                <div className="footer-nav bg-transparent shadow-sm position-relative">
                  <ul className="m-0 bg-transparent">
                    <li className="text-white fw-bold">
                      <span>T</span>
                      <span>{counts.T}</span>
                    </li>
                    <li className="text-success fw-bold">
                      <span>P</span>
                      <span>{counts?.P}</span>
                    </li>
                    <li className="text-danger fw-bold">
                      <span>A</span>
                      <span>{counts?.A}</span>
                    </li>
                    <li className="text-info fw-bold">
                      <span>L</span>
                      <span>{counts?.L}</span>
                    </li>
                    <li className="text-warning fw-bold">
                      <span>H</span>
                      <span>{counts?.H}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <Modal
              show={showEditModal}
              onHide={() => {
                setShowEditModal(false);
                setSelectedRow(null);
              }}
              centered
            >
              <Form onSubmit={handleUpdate}>
                <Modal.Header closeButton>
                  <Modal.Title>{selectedRow?.studentName}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                  {/* Hidden Inputs */}
                  <Form.Control
                    type="hidden"
                    name="attendanceId"
                    value={selectedRow?.attendanceId}
                  />
                  <Form.Control
                    type="hidden"
                    name="enrollId"
                    value={selectedRow?.enrollId}
                  />

                  {/* Remarks Input */}
                  <Form.Group className="mb-3" controlId="remarksInput">
                    <Form.Label>Remarks</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="remarks"
                      defaultValue={selectedRow?.remark}
                      placeholder="Enter remarks..."
                    />
                  </Form.Group>

                  {/* Attendance Radio Buttons */}
                  <Form.Group className="mb-3">
                    <Form.Label>Attendance Status</Form.Label>
                    <div className="d-flex justify-content-between flex-wrap">
                      {["P", "A", "H", "L"].map((status) => (
                        <Form.Check
                          key={status}
                          type="radio"
                          name="attendance"
                          id={`status-${status}`}
                          label={
                            status === "P"
                              ? "Present"
                              : status === "A"
                              ? "Absent"
                              : status === "H"
                              ? "Holiday"
                              : "Leave"
                          }
                          value={status}
                          defaultChecked={selectedRow?.status === status}
                          className={`me-3 `}
                          style={{
                            accentColor:
                              status === "P"
                                ? "#198754" // Bootstrap success
                                : status === "A"
                                ? "#dc3545" // Bootstrap danger
                                : status === "H"
                                ? "#ffc107" // Bootstrap warning
                                : "#0dcaf0", // Bootstrap info
                          }}
                        />
                      ))}
                    </div>
                  </Form.Group>
                </Modal.Body>

                <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={() => {
                      setShowEditModal(false);
                      setSelectedRow(null);
                    }}
                  >
                    Cancel
                  </Button>
                  <Button type="submit" variant="primary">
                    <i className="fa fa-refresh me-1" /> Update
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal>
            {selectedRow && (
              <Modal
                size="lg"
                backdrop="static"
                centered
                onHide={() => {
                  setShowNoteModal(false);
                  setSelectedRow(null);
                }}
                show={showNoteModal}
              >
                <Modal.Header className="p-0 py-2 px-3" closeButton>
                  Note
                </Modal.Header>
                <Modal.Body>
                  <form id="studentNoteForm" onSubmit={handleAddNote}>
                    <input
                      type="hidden"
                      name="id"
                      value={selectedRow?.studentId}
                    />
                    <textarea
                      name="note"
                      value={selectedRow?.note}
                      id=""
                      placeholder="Enter Note..."
                      className="form-control"
                    ></textarea>
                  </form>
                </Modal.Body>
                <Modal.Footer className="p-0 py-2 px-3">
                  <button
                    onClick={() => {
                      setShowNoteModal(false);
                      setSelectedRow(null);
                    }}
                    className="btn btn-outline-primary"
                  >
                    Close
                  </button>
                  <button
                    form="studentNoteForm"
                    className="btn btn-outline-danger"
                  >
                    Save Changes
                  </button>
                </Modal.Footer>
              </Modal>
            )}
          </>
        )}
      </div>
    </>
  );
}

function StatusMessage({ status }) {
  // console.log('here ', status);

  return status === "sunday" ? (
    <>
      <div className="mb-5" role="alert"></div>
      <img
        src={NoData}
        alt=""
        style={{
          mixBlendMode: "multiply",
        }}
      />
      <div className="text-center" role="alert">
        <span className="fw-bold fz-18">Selected day is Sunday.</span>
        <br />
        <small>Please select another day.</small>
      </div>
    </>
  ) : (
    <>
      <div className="mb-5" role="alert"></div>
      <img
        src={NoData}
        alt=""
        style={{
          mixBlendMode: "multiply",
        }}
      />
      <div className="text-center" role="alert">
        <span className="fw-bold fz-18">No Data Available.</span>
        <br />
        {/* <small>
          Please select another day.
        </small> */}
      </div>
    </>
  );
}
// Placeholders
function Placeholders() {
  return (
    <>
      <div className="card mb-2" aria-hidden="true">
        <div className="card-body">
          <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
            <span className="placeholder col-6 rounded-2"></span>
            <span className="placeholder col-5 rounded-2"></span>
          </h5>
          <p className="card-text d-flex justify-content-between placeholder-glow">
            <span className="placeholder col-12 py-2 rounded-2"></span>
          </p>
        </div>
      </div>

      <div className="card mb-2" aria-hidden="true">
        <div className="card-body">
          <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
            <span className="placeholder col-5 rounded-2"></span>
            <span className="placeholder col-5 rounded-2"></span>
          </h5>
          <p className="card-text d-flex justify-content-between placeholder-glow">
            <span className="placeholder col-12 py-2 rounded-2"></span>
          </p>
        </div>
      </div>
      <div className="card mb-2" aria-hidden="true">
        <div className="card-body">
          <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
            <span className="placeholder col-5 rounded-2"></span>
            <span className="placeholder col-5 rounded-2"></span>
          </h5>
          <p className="card-text d-flex justify-content-between placeholder-glow">
            <span className="placeholder col-12 py-2 rounded-2"></span>
          </p>
        </div>
      </div>
      <div className="card mb-2" aria-hidden="true">
        <div className="card-body">
          <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
            <span className="placeholder col-5 rounded-2"></span>
            <span className="placeholder col-5 rounded-2"></span>
          </h5>
          <p className="card-text d-flex justify-content-between placeholder-glow">
            <span className="placeholder col-12 py-2 rounded-2"></span>
          </p>
        </div>
      </div>
      <div className="card mb-2" aria-hidden="true">
        <div className="card-body">
          <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
            <span className="placeholder col-5 rounded-2"></span>
            <span className="placeholder col-5 rounded-2"></span>
          </h5>
          <p className="card-text d-flex justify-content-between placeholder-glow">
            <span className="placeholder col-12 py-2 rounded-2"></span>
          </p>
        </div>
      </div>
      <div className="card mb-2" aria-hidden="true">
        <div className="card-body">
          <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
            <span className="placeholder col-5 rounded-2"></span>
            <span className="placeholder col-5 rounded-2"></span>
          </h5>
          <p className="card-text d-flex justify-content-between placeholder-glow">
            <span className="placeholder col-12 py-2 rounded-2"></span>
          </p>
        </div>
      </div>
      <div className="card mb-2" aria-hidden="true">
        <div className="card-body">
          <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
            <span className="placeholder col-5 rounded-2"></span>
            <span className="placeholder col-5 rounded-2"></span>
          </h5>
          <p className="card-text d-flex justify-content-between placeholder-glow">
            <span className="placeholder col-12 py-2 rounded-2"></span>
          </p>
        </div>
      </div>
      <div className="card mb-2" aria-hidden="true">
        <div className="card-body">
          <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
            <span className="placeholder col-5 rounded-2"></span>
            <span className="placeholder col-5 rounded-2"></span>
          </h5>
          <p className="card-text d-flex justify-content-between placeholder-glow">
            <span className="placeholder col-12 py-2 rounded-2"></span>
          </p>
        </div>
      </div>
      <div className="card mb-2" aria-hidden="true">
        <div className="card-body">
          <h5 className="card-title d-flex justify-content-between placeholder-glow mb-3">
            <span className="placeholder col-5 rounded-2"></span>
            <span className="placeholder col-5 rounded-2"></span>
          </h5>
          <p className="card-text d-flex justify-content-between placeholder-glow">
            <span className="placeholder col-12 py-2 rounded-2"></span>
          </p>
        </div>
      </div>
    </>
  );
}

export default TeacherAttendance;
